import { createSlice } from '@reduxjs/toolkit';

const commonSlice = createSlice({
  name: 'common',
  initialState: {
    selectedLocal: '전체',
    isErrorDialogOpen: false,
    errorDialogStatus: '',
    isLoading: false
  },
  reducers: {
    setSelectedLocal: (state, action) => {
      state.selectedLocal = action.payload;
    },
    setIsErrorDialogOpen: (state, action) => {
      state.isErrorDialogOpen = action.payload;
    },
    setErrorDialogStatus: (state, action) => {
      state.errorDialogStatus = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    }
  }
});

export const { setSelectedLocal, setIsErrorDialogOpen, setErrorDialogStatus, setIsLoading } = commonSlice.actions;
export const selectSelectedLocal = state => state.common.selectedLocal;
export const selectIsErrorDialogOpen = state => state.common.isErrorDialogOpen;
export const selectErrorDialogStatus = state => state.common.errorDialogStatus;
export const selectIsLoading = state => state.common.isLoading;
export default commonSlice;
